import gql from "graphql-tag";

export const SUBSCRIBE_TO_PLAN = gql`
  mutation SubscribeToPlan($planId: ID!) {
    subscribeToPlan(planId: $planId)
  }
`;
